import { buildStyles, CircularProgressbarWithChildren } from "react-circular-progressbar";

interface PrimaryDialProps {
    value: number;
    threshold: number;
    midText: string;
    texts: DialSideText[]
}
export interface DialSideText {
    name: string;
    value: number;
}

export default function PrimaryDial(primaryDialProps: PrimaryDialProps) {
    const value = primaryDialProps.value;
    const pathColor = primaryDialProps.value > primaryDialProps.threshold ? "#00B464" : "#FCC449";

    return <>
        <div className='flex justify-center mt-2'>
            <div className='flex justify-center items-center '>
                <div className="p-1" >
                    <div style={{ width: '10.5rem', height: '10.5rem' }} >
                        <CircularProgressbarWithChildren value={value}
                            backgroundPadding={0}
                            strokeWidth={15}
                            background
                            styles={buildStyles({
                                pathColor: pathColor,
                                backgroundColor: "#494949",
                                trailColor: "#494949",
                                strokeLinecap: "butt"
                            })} >
                            <div className='text-center pt-12 text-xs text-text-dark mb-4'>{primaryDialProps.midText}</div>
                        </CircularProgressbarWithChildren>
                    </div>
                </div>
                <div className="absolute text-4xl font-bold text-text-dark mb-4">
                    {Math.round(value)}%
                </div>
            </div>

        </div>
    </>
}
